// assets
import MailOutlined from '@ant-design/icons/MailOutlined';

// icons
const icons = { MailOutlined };

// ==============================|| MENU ITEMS - CONTACT ||============================== //

const contact = {
  id: 'group-contact',
  title: 'Support',
  type: 'group',
  children: [
    {
      id: 'contact-messages',
      title: 'Contact Messages',
      type: 'item',
      url: '/contact',
      icon: icons.MailOutlined,
      breadcrumbs: false
    }
  ]
};

export default contact;
